import Idm from 'components/internal-data-management/Idm.jsx'
import clientPromise from "lib/mddb.mjs";
import computeFields from "lib/computeFields";
import fs from "fs";
import React from "react";

export default function InternalDataManagement({blogs})
{
  return(
    <Idm blogs={blogs}  />
  )
}

export async function getStaticProps() {
  const mddb = await clientPromise;

  const blogFiles = await mddb.getFiles({ folder: "blog" });

  const blogsMetadataPromises = blogFiles.map(async (b) => {
    const source = fs.readFileSync(b.file_path, { encoding: "utf-8" });

    // TODO temporary replacement for contentlayer's computedFields
    const frontMatterWithComputedFields = await computeFields({
      frontMatter: b.metadata,
      urlPath: b.url_path,
      filePath: b.file_path,
      source,
    });
    return frontMatterWithComputedFields;
  });

  const blogsList = await Promise.all(blogsMetadataPromises);

  return {
    props: {
      meta: {
        title: "Internal Data Management",
        description: "A good data management system helps your teams locate, store, secure, share, and version your data. Your data needs, sorted.",
      },
      blogs: blogsList,
    },
  };
};
